import { useEffect, useState } from "react";
import { useParams, useLocation, Link } from "react-router-dom";
import axios from "axios";
import Navbar from "../components/Navbar";
import { CheckCircle, XCircle, Loader2, AlertTriangle } from "lucide-react";
import { Button } from "../components/ui/button";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function BarApprovalCallback() {
  const { barId, token } = useParams();
  const location = useLocation();
  const [status, setStatus] = useState("loading"); // loading, success, error, already
  const [message, setMessage] = useState("");
  
  // Determine action from URL path
  const action = location.pathname.includes("approve-bar") ? "approve" : "reject";

  useEffect(() => {
    const processApproval = async () => {
      try {
        const endpoint = action === "approve" 
          ? `/bars/approve/${barId}/${token}`
          : `/bars/reject/${barId}/${token}`;
        
        const res = await axios.get(`${API}${endpoint}`);
        
        if (res.data.already_approved) {
          setStatus("already");
          setMessage("Este bar ya había sido aprobado anteriormente.");
        } else if (res.data.approved) {
          setStatus("success");
          setMessage("El bar ha sido aprobado correctamente. Se ha enviado un email de confirmación al propietario.");
        } else if (res.data.rejected) {
          setStatus("rejected");
          setMessage("El bar ha sido rechazado y eliminado. Se ha notificado al solicitante.");
        }
      } catch (error) {
        setStatus("error");
        setMessage(error.response?.data?.detail || "El enlace es inválido o ha expirado.");
      }
    };

    processApproval();
  }, [barId, token, action]);

  return (
    <div className="min-h-screen bg-[#0a0a0a]">
      <Navbar />
      
      <div className="max-w-lg mx-auto px-4 py-20">
        <div className="bg-[#111] border border-zinc-800 p-8 text-center">
          {status === "loading" && (
            <>
              <Loader2 className="w-16 h-16 text-primary mx-auto mb-4 animate-spin" />
              <h1 className="text-2xl font-black text-white mb-2">PROCESANDO...</h1>
              <p className="text-zinc-500 font-mono text-sm">Espera un momento</p>
            </>
          )}

          {status === "success" && (
            <>
              <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-4" />
              <h1 className="text-2xl font-black text-green-500 mb-4">BAR APROBADO</h1>
              <p className="text-zinc-400 mb-6">{message}</p>
              <Link to="/admin">
                <Button className="bg-primary hover:bg-red-700 text-white font-mono">
                  IR AL PANEL ADMIN
                </Button>
              </Link>
            </>
          )}

          {status === "already" && (
            <>
              <AlertTriangle className="w-16 h-16 text-yellow-500 mx-auto mb-4" />
              <h1 className="text-2xl font-black text-yellow-500 mb-4">YA APROBADO</h1>
              <p className="text-zinc-400 mb-6">{message}</p>
              <Link to="/admin">
                <Button className="bg-primary hover:bg-red-700 text-white font-mono">
                  IR AL PANEL ADMIN
                </Button>
              </Link>
            </>
          )}

          {status === "rejected" && (
            <>
              <XCircle className="w-16 h-16 text-red-500 mx-auto mb-4" />
              <h1 className="text-2xl font-black text-red-500 mb-4">BAR RECHAZADO</h1>
              <p className="text-zinc-400 mb-6">{message}</p>
              <Link to="/admin">
                <Button className="bg-primary hover:bg-red-700 text-white font-mono">
                  IR AL PANEL ADMIN
                </Button>
              </Link>
            </>
          )}

          {status === "error" && (
            <>
              <XCircle className="w-16 h-16 text-red-500 mx-auto mb-4" />
              <h1 className="text-2xl font-black text-red-500 mb-4">ERROR</h1>
              <p className="text-zinc-400 mb-6">{message}</p>
              <Link to="/">
                <Button className="bg-primary hover:bg-red-700 text-white font-mono">
                  VOLVER AL INICIO
                </Button>
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
